import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    email:               null,
    projectName:         null,
    projectId:           null,
    organizationName:    null,
    roleId:              null,       // kept for backward compat — not used for access control
    projectsData:        [],         // full array from /api/project-summary/
    viewIds:             [],         // ← views_list of the CURRENTLY selected project
    isSuperuser:         false,
  },
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },

    // Called when user clicks "View Details" on a project card
    setProjectDetails: (state, action) => {
      const { email, projectName, projectId, organizationName, roleId, viewIds } = action.payload;
      if (email            !== undefined) state.email            = email;
      if (projectName      !== undefined) state.projectName      = projectName;
      if (projectId        !== undefined) state.projectId        = projectId;
      if (organizationName !== undefined) state.organizationName = organizationName;
      if (roleId           !== undefined) state.roleId           = roleId ?? null;
      // Store the selected project's views_list so every component can use it
      if (viewIds          !== undefined) state.viewIds          = viewIds ?? [];
    },

    setRoleId: (state, action) => {
      state.roleId = action.payload;
    },

    // Called once after login fetches all projects
    setProjectsData: (state, action) => {
      const projects      = action.payload || [];
      state.projectsData  = projects;
      state.isSuperuser   = projects.some(p => p.user_type === "superuser");
    },
  },
});

export const { setEmail, setProjectDetails, setRoleId, setProjectsData } = userSlice.actions;
export default userSlice.reducer;